export const msgTypeCharFieldsUpdate = "char.fields.update"
export const msgTypeCharSkillsAdd = "char.skills.add"
export const msgTypeCharSkillsUpdate = "char.skills.update"
export const msgTypeCharModsAdd = "char.mods.add"
export const msgTypeCharModsUpdate = "char.mods.update"
export const msgTypeCharModsDelete = "char.mods.delete"
export const msgTypeCharModsSourceDelete = "char.mods.source.delete"
export const msgTypeCharModsSourceAdd = "char.mods.source.add"
export const msgTypeCharNotesAdd = "char.notes.add"
export const msgTypeCharNotesUpdate = "char.notes.update"
export const msgTypeCharTalentsAdd = "char.talentes.add"
export const msgTypeCharTalentsUpdate = "char.talentes.update"
export const msgTypeIniClear = 'ini.clear'
export const msgTypeIniAdd = 'ini.add'
export const msgTypeIniSetNext = 'ini.set.next';
export const msgTypeIni = "ini"
export const msgTypeIniNewRound = 'ini.newround';
export const msgTypeIniSetCurrent = 'ini.set.current';
export const msgTypeOnOpen = 'onopen'
export const msgTypeResultsAdd = 'results.add'
export const msgTypeResultsClear = 'results.clear'
export const msgTypeResults = 'results'